'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _Dropdown = require('./Dropdown');

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _PersonalBox = require('../containers/PersonalBox');

var _PersonalBox2 = _interopRequireDefault(_PersonalBox);

var _PointBox = require('../containers/PointBox');

var _PointBox2 = _interopRequireDefault(_PointBox);

var _logo = require('../img/common/logo.gif');

var _logo2 = _interopRequireDefault(_logo);

var _logo_tw = require('../img/common/logo_tw.gif');

var _logo_tw2 = _interopRequireDefault(_logo_tw);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// containers
function Header(props) {
  var currency = props.currency,
      currencies = props.currencies,
      domains = props.domains,
      i18n = props.i18n,
      urls = props.urls,
      onCurrencyChange = props.onCurrencyChange,
      isMobile = props.isMobile;


  return _react2.default.createElement(
    'div',
    { id: 'header' },
    _react2.default.createElement(
      'div',
      { className: 'nav-primary' },
      _react2.default.createElement(
        'div',
        { className: 'brand' },
        _react2.default.createElement(
          _reactRouter.Link,
          { to: urls.app.root, className: 'logo' },
          i18n.header.title,
          _react2.default.createElement('img', { src: i18n.lang !== 'zh_TW' ? _logo2.default : _logo_tw2.default, alt: i18n.header.title, width: 118, height: 41 })
        )
      ),
      _react2.default.createElement(
        'ul',
        { className: 'nav-utility list-nav' },
        _react2.default.createElement(
          _Dropdown2.default,
          { className: 'currencies', isMobile: isMobile },
          _react2.default.createElement(
            'div',
            { 'data-role': 'dropdown', 'data-position': 'right,bottom', className: 'nav-tile' },
            _react2.default.createElement(
              'span',
              { className: 'nav-label', id: 'currencyShow' },
              currency.id
            )
          ),
          currencies.length ? _react2.default.createElement(
            'div',
            { 'data-role': 'dropdown-content', className: 'nav-tile-content for-currency' },
            _react2.default.createElement(
              'ul',
              { className: 'list-fluid' },
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'a',
                  { href: '' },
                  _react2.default.createElement(
                    'span',
                    { className: 'currencies-simbol', id: 'defaultSymbol' },
                    currency.id
                  ),
                  _react2.default.createElement(
                    'span',
                    { id: 'defaultName' },
                    currency.name
                  )
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'a',
                  {
                    href: '',
                    onClick: function onClick(e) {
                      e.preventDefault();
                      onCurrencyChange('JPY');
                    }
                  },
                  _react2.default.createElement(
                    'span',
                    { className: 'currencies-simbol' },
                    '$\u20AC'
                  ),
                  _react2.default.createElement(
                    'span',
                    null,
                    i18n.header.propertysCurrency
                  )
                )
              )
            ),
            _react2.default.createElement(
              'dl',
              { className: 'dl-vertical' },
              _react2.default.createElement(
                'dt',
                null,
                i18n.header.allCurrencies
              ),
              _react2.default.createElement(
                'dd',
                null,
                _react2.default.createElement(
                  'ul',
                  { className: 'list-fluid', id: 'currencyUl' },
                  currencies.map(function (currency) {
                    return _react2.default.createElement(
                      'li',
                      { id: 'currencyLi', key: currency.id },
                      _react2.default.createElement(
                        'a',
                        { href: '',
                          onClick: function onClick(e) {
                            e.preventDefault();
                            onCurrencyChange(currency.id);
                          }
                        },
                        _react2.default.createElement(
                          'span',
                          { className: 'currencies-simbol' },
                          currency.id
                        ),
                        _react2.default.createElement(
                          'span',
                          { className: 'currencies-name' },
                          currency.name
                        )
                      )
                    );
                  })
                )
              )
            )
          ) : null
        ),
        _react2.default.createElement('input', { id: 'defaulCurrency', type: 'hidden', defaultValue: currency.id }),
        _react2.default.createElement('input', { id: 'searchCurrency', type: 'hidden', defaultValue: currency.id }),
        _react2.default.createElement('input', { id: 'isSupportSuperPoint', type: 'hidden', defaultValue: 'false' }),
        _react2.default.createElement(
          _Dropdown2.default,
          { className: 'language', isMobile: isMobile },
          _react2.default.createElement(
            'div',
            { 'data-role': 'dropdown', 'data-position': 'right,bottom', className: 'nav-tile' },
            _react2.default.createElement('span', { id: 'flag', className: domains.collection[domains.index].suffix }),
            _react2.default.createElement('span', { className: 'nav-label hide' })
          ),
          _react2.default.createElement(
            'div',
            { 'data-role': 'dropdown-content', className: 'nav-tile-content' },
            _react2.default.createElement(
              'ul',
              { className: 'list-fluid' },
              (0, _keys2.default)(domains.collection).filter(function (key) {
                return key !== 'index';
              }).map(function (domain) {
                return _react2.default.createElement(
                  'li',
                  { key: domain },
                  _react2.default.createElement(
                    'a',
                    { href: domain },
                    _react2.default.createElement('span', { className: domains.collection[domain].suffix }),
                    _react2.default.createElement(
                      'span',
                      { className: 'language-name' },
                      domains.collection[domain].languageName
                    )
                  )
                );
              })
            )
          )
        ),
        _react2.default.createElement(_PersonalBox2.default, null),
        _react2.default.createElement(_PointBox2.default, null)
      )
    )
  );
}
// components
// Header

Header.propTypes = {
  currency: _react.PropTypes.object.isRequired,
  currencies: _react.PropTypes.arrayOf(_react.PropTypes.object).isRequired,
  domains: _react.PropTypes.object.isRequired,
  i18n: _react.PropTypes.object.isRequired,
  urls: _react.PropTypes.object.isRequired,
  onCurrencyChange: _react.PropTypes.func.isRequired,
  isMobile: _react.PropTypes.bool.isRequired
};

exports.default = Header;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Header.js
// module id = 1207
// module chunks = 0